﻿/**
* DevExpress Analytics (core\binding\_requestHelper.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RequestHelper = (function () {
    function RequestHelper() {
    }
    RequestHelper.generateUri = function (host, uri) {
        host = host || '';
        if (host && host[host.length - 1] === '/' && uri && uri[0] === '/') {
            return host + uri.substring(1);
        }
        return host + uri;
    };
    return RequestHelper;
}());
exports.RequestHelper = RequestHelper;
